import { render } from "./UserJobTickets.vue?vue&type=template&id=25c412c3&ts=true"
import script from "./UserJobTickets.vue?vue&type=script&lang=ts"
export * from "./UserJobTickets.vue?vue&type=script&lang=ts"

import "./UserJobTickets.vue?vue&type=style&index=0&id=25c412c3&lang=scss"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__